import { IProduct } from '../components'

export interface IReorderItem {
  product: IProduct
  quantity: number
}

export interface IReorder {
  [key: number]: IReorderItem[]
}

export interface ICustomerOrder {
  created_at: string
  id: string
  name: string
  isFavourite: boolean
  isLastOrder: boolean
  customer: {
    id: string
  },
  line_items: IReorderItem[],
  customer_url: string,
  attributes: {
    delivery_day: string
  },
  fulfillment_status: OrderFulfillmentStatus,
  total_price: string
}

export enum OrderFulfillmentStatus {
  unfulfilled = 'unfulfilled'
}